require('./bootstrap');
require('@fortawesome/fontawesome-free/js/all.js');
require('owl.carousel/dist/owl.carousel')
